module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/268.da4a46f7.png";